/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-10-26 13:48:39 */

const Keys = {
  from: 'from',
  to: 'to',
  night: 'night',
  night_other: 'night_other',
  week: 'week',
  week_other: 'week_other',
  nightComma: 'nightComma',
  nightComma_other: 'nightComma_other',
  weekComma: 'weekComma',
  weekComma_other: 'weekComma_other',
  chooseDuration: 'chooseDuration',
  chooseRangeLabel: 'chooseRangeLabel',
  durationPlaceholder: 'durationPlaceholder',
  submit: 'submit',
  offer: 'offer',
  busy: 'busy',
  available: 'available',
  ARIA_LABEL_datePickerButton: 'ARIA_LABEL_datePickerButton',
  nights: 'nights',
  weeks: 'weeks',
  weeks_other: 'weeks_other',
  advancedNight: 'advancedNight',
  advancedNight_other: 'advancedNight_other',
  minimumStay: 'minimumStay',
  minimumStay_other: 'minimumStay_other',
  invalidDateFormat: 'invalidDateFormat',
  invalidDateWithFormat: 'invalidDateWithFormat',
  invalidMinDate: 'invalidMinDate',
  invalidMaxDate: 'invalidMaxDate',
  datePickerModalHeader: 'datePickerModalHeader'
}; export default Keys;